export default {
  countries: {
    data: null,
    loading: false,
    error: null,
  },
  stores: {
    data: null,
    loading: false,
    error: null,
  },
  storePendingVouchers: {
    data: null,
    loading: false,
    error: null,
  },

  rejectVoucher: {
    data: null,
    loading: false,
    error: null,
  },

  searchStore: {
    data: null,
    loading: false,
    error: null,
  },
  verifyVoucher: {
    data: null,
    loading: false,
    error: null,
  },
  redeemVoucher: {
    data: null,
    loading: false,
    error: null,
  },

  createVoucher: {
    error: null,
    loading: false,
    success: false,
  },
  selectedStore: {
    data: null,
    skipSearchPage: false,
  },
};
